import { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import WordColumnsContainer from "./WordColumnsContainer";

const NewsiePreview = ({ organization, handleSubmit, newsieInput, takeAwayPoints  }) => {

  console.log(newsieInput)

  return (
    <WordColumnsContainer newsieGrid={newsieInput} takeAwayPoints={takeAwayPoints}  />
  );
};

export default NewsiePreview;
